import { Component } from '@angular/core';

@Component({
  selector: 'app-time-entries-calendar-view',
  templateUrl: './time-entries-calendar-view.component.html',
  standalone: false,
})
export class TimeEntriesCalendarViewComponent {}
